// @core/api/endpoints/platform/set_platform_product_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformProductResponse,
  SetPlatformProductStatusRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Set platform product status
 * Changes the availability status of a product on the platform. Status can be enabled, disabled, beta, coming_soon, or deprecated.
 */
export async function SetPlatformProductStatus(
  platform_id: string,
  product_id: string,
  data: SetPlatformProductStatusRequest,
  options?: RequestOptions
): Promise<PlatformProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/products/:product_id/status`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<PlatformProductResponse>(requestPath, data, requestOptions);
}
